import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { Paths } from "src/constants";

const SignedOutPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <Stack spacing={0.25} sx={{ alignItems: "center", textAlign: "center", width: "fit-content" }}>
        <Typography variant="h3">Signed Out</Typography>
        <Typography>You have been signed out and may now close this browser window.</Typography>
        <Box>
          <Button variant="contained" sx={{ mt: 0.75 }} onClick={() => navigate(Paths.Home)}>
            Sign In
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export { SignedOutPage };
